function o(e) {
  const s = e.match(/\s[\w\W]"([\w]*)\\/g);
  return Array.isArray(s) && s.map((a) => {
    const r = a.match(/"([\w]*)\\/);
    return Array.isArray(r) ? r[1] : "";
  }) || [];
}
function y(e) {
  var c, a, r;
  return ((r = (a = (c = e == null ? void 0 : e.match(/<em\s*.*>\s*.*<\/em>/g)) == null ? void 0 : c[0]) == null ? void 0 : a.replace("<em>", "")) == null ? void 0 : r.replace("</em>", "")) ?? "New Security Key";
}
export {
  y as parseDeviceNameText,
  o as parseDisplayRecoveryCodesText
};
